import CategoriesTab from './CategoriesTab'
export default CategoriesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/CategoriesTab/index.js